import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_ui1fHqCmhW8F: {
	id: 'prd_ui1fH2DEV2qCmhW8F'
	ident: 'prd_ui1fHqCmhW8F'
	sku: 'simple_premium_6m_31_99_6m_139_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 6
			iteration_count: 1
			price_id: 'prc_HeZjX2DEV2VJqNhxp'
			amount: 139
			amount_usd: 31.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 31.99
			discount: 107.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 6
			iteration_count: null
			price_id: 'prc_jA0sw2DEV2y5G5tUM'
			amount: 139
			amount_usd: 139
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_ui1fHqCmhW8F, SubscriptionProduct>
const prd_ui1fHqCmhW8F = { ident: 'prd_ui1fHqCmhW8F' } as typeof _prd_ui1fHqCmhW8F

export default prd_ui1fHqCmhW8F
